function setMap(place, lat, long) {
    mapboxgl.accessToken = "pk.eyJ1IjoiY29sZG93b2xkbyIsImEiOiJjbGdudDNkZ2cwYjl4M25rMmI4NjI2MXRmIn0.KtVJLaVs5Hu_bRMM0mlI_g";

    const slugPlace = convertToSlug(place);

    const map = new mapboxgl.Map({
        container: `office-map-${slugPlace}`, // container ID
        style: "mapbox://styles/mapbox/streets-v11", // style URL
        center: [long, lat], // starting position
        zoom: 13, // starting zoom
    });

    map.on("load", () => {
        const el = document.createElement("div");
        el.classList.add("marker");
        new mapboxgl.Marker(el).setLngLat([long, lat]).addTo(map);
    });
}

function setMaps(offices) {
    for (let i = 0; i < offices.length; i++) {
        let office = offices[i];
        setMap(office.name, office.latitude, office.longitude);
    }
}

function getOffices() {
    $.ajax("/xhr/getOffices.php", {
        type: "POST",
        async: false,
        success: (response) => {
            if (response.success) {
                setMaps(response.success);
            }
        },
    });
}

function convertToSlug(Text) {
    return Text.toLowerCase()
        .replace(/ /g, "-")
        .replace(/[^\w-]+/g, "");
}

const officeMaps = document.querySelectorAll(".js-office-map");
if (officeMaps.length > 0) {
    getOffices();
}
